'use strict'

import * as dot from 'dot-object'
import * as _ from 'lodash'
import moment from 'moment'

import tabelle from '@/services/tabelleService'
import configurazioni from '@/services/configurazioniService'
import { sanitize } from '@/components/helpers'

export const creaElementi = async function (dati, datiDefault, valoriDefault, riferimento, forzaAggiornamento) {
  const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
  console.log(impostazioni)
  let aggio = _.get(impostazioni, 'ordiniPeriodici.aggioPercentuale') || 10
  aggio = aggio / 100
  console.log('Aggio:' + aggio)

  let tabella = await tabelle.getTabella('anagrafica_tabacchi')
  let esistenti = tabella.tabacchi
  let tabacchi = dati.filter(x => String(x.codiceFornitore).length > 0).map(pr => {
    let pobj = dot.object({ ...pr })
    _.merge(pobj, datiDefault)
    pobj.hash = calcolaHash(pobj)
   
    return pobj
  })
  // TODO: ATTENZIONE: Come prendo i barcode dei prodotti presenti su Fata ? Va fatta una procedura di lettura da mdb ...
  const daAggiungere = []
  const daModificare = []

  for(let t of tabacchi) {
    let ee = esistenti.find(x => String(x.codiceFornitore) === String(t.codiceFornitore))
    if (!ee) {
      // completare i valori
      t.elencoBarcode = []
      t.riordino = 10
      t.costo = +(parseFloat(t.prezzoConfezione) * (1 - aggio)).toFixed(2)
      daAggiungere.push(t)
    } else {
      const hs = calcolaHash(t)
      if (!ee.hash || ee.hash !== hs || forzaAggiornamento) {
        t.costo = +(parseFloat(t.prezzoConfezione) * (1 - aggio)).toFixed(2)
        daModificare.push(t)
      }
    }
  }

  tabella.tabacchi = tabella.tabacchi.concat(daAggiungere)
  for (let t of daModificare) {
    let idx = tabella.tabacchi.findIndex(x => String(x.codiceFornitore) === String(t.codiceFornitore))
    if (idx > -1) {
      let tt = tabella.tabacchi[idx]
      tt = { ...tt, ...t }
      const hs = calcolaHash(tt)
      tt.hash = hs
      tabella.tabacchi[idx] = tt
    }
  }
  try {
    let datiModificati = false
    if (!tabella.impostazioni.ultimaElaborazione || moment().diff(tabella.impostazioni.ultimaElaborazione, 'hours') > 12) {
      datiModificati = true
    }
    if (daAggiungere.length > 0 || daModificare.length > 0) {
      tabella.impostazioni.ultimaModifica = new Date()
      datiModificati = true
    }

    if (datiModificati) {
      tabella.impostazioni.ultimaElaborazione = new Date()
      await tabelle.creaRigaTabella(tabella)
    }
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaElementi: ${error}`)
    return []
  }    
}

function calcolaHash(obj) {
  // -----------------------------------------
  // Eliminare dal calcolo eventuali parametri che non devono essere verificati in modifica
  // es.: delete obj.riordino
  // ------------------------------------------
  // delete obj.hash

  const toHash = {
    categoria: obj.categoria,
    codiceFornitore: obj.codiceFornitore,
    denominazione: obj.denominazione,
    prezzoConfezione: obj.prezzoConfezione,
    prezzoKg: obj.prezzoKg,
    prezzoConfezione: obj.prezzoConfezione, 
    tipoConfezione: obj.tipoConfezione,
    costo: obj.costo,
    confezione: obj.confezione || '',
    elencoBarcode: obj.elencoBarcode || []
  }
  const value = JSON.stringify(toHash)
  var hash = 0;
  if (value.length === 0) return hash;
  for (let i = 0; i < value.length; i++)
  {
    const ch = value.charCodeAt(i);
    hash = ((hash << 5) - hash) + ch;
    hash = hash & hash;
  }
  return hash;
}

export const creaElementiCategoria = async function (dati, datiDefault, valoriDefault, riferimento, forzaAggiornamento) {
  let backoffice = await configurazioni.getConfigurazione('backoffice')
  const impostazioni = backoffice.impostazioni

  let anagrafica = await tabelle.getTabella('anagrafica_tabacchi')

  let tabelleImport = anagrafica.impostazioni.tabelleImport // _.get(impostazioni, 'ordiniPeriodici.tabelleImport') || []
  console.log(impostazioni)
  let aggio = _.get(impostazioni, 'ordiniPeriodici.aggioPercentuale') || 10
  aggio = aggio / 100
  console.log('Aggio:' + aggio)

  let tabelleT = {}

  // Solo la prima volta --> crea le tabelle copiando la principale ---------------
/*   let tabella = await tabelle.getTabella('anagrafica_tabacchi')
  for (let r of tabella.tabacchi) {
    const catSan = sanitize(r.categoria, true)
    if (!tabelleImport.includes(catSan)) {
      tabelleImport.push(catSan)
    }
    if (!tabelleT[catSan]) {
      tabelleT[catSan] = {
        _id: `anagrafica_tabacchi_${catSan}`,
        impostazioni: {
          ultimaElaborazione: null,
          ultimaModifica: null
        },
        tabacchi: []
      }
    }
    tabelleT[catSan].tabacchi.push(r)
  }
  for (let t of tabelleImport) {
    debugger
    await tabelle.creaRigaTabella(tabelleT[t])
  } 
  return  
  */
  // ----------------------------------------------------------------

  let esistenti = []
  for (let t of tabelleImport) {
    const tabname = `anagrafica_tabacchi_${t}`
    tabelleT[t] = await tabelle.getTabella(tabname)
    esistenti = esistenti.concat(tabelleT[t].tabacchi)
  }

  let tabacchi = dati.filter(x => String(x.codiceFornitore).length > 0).map(pr => {
    let pobj = dot.object({ ...pr })
    _.merge(pobj, datiDefault)
    pobj.hash = calcolaHash(pobj)
   
    return pobj
  })

  const daAggiungere = {}
  const daModificare = {}
  const daCancellare = {}
  let aggiuntaTabella = false
  for(let t of tabacchi) {
    const catSan = sanitize(t.categoria, true)
    if (!tabelleImport.includes(catSan)) {
      aggiuntaTabella = true
      tabelleImport.push(catSan)
      console.log('Nuova categoria da aggiungere su backoffice.ordiniPeriodici.tabelleImport', catSan)
      tabelleT[catSan] = {
        _id: `anagrafica_tabacchi_${catSan}`,
        impostazioni: {
          ultimaElaborazione: null,
          ultimaModifica: null
        },
        tabacchi: []
      }
    }
    let ee = esistenti.find(x => String(x.codiceFornitore) === String(t.codiceFornitore))
    if (!ee) {
      t.elencoBarcode = []
      t.riordino = 10
      t.costo = +(parseFloat(t.prezzoConfezione) * (1 - aggio)).toFixed(2)
      
      daAggiungere[catSan] = daAggiungere[catSan] || []
      daAggiungere[catSan].push(t)
    } else {
      const hs = calcolaHash(t)
      if (!ee.hash || ee.hash !== hs || forzaAggiornamento) {
        t.costo = +(parseFloat(t.prezzoConfezione) * (1 - aggio)).toFixed(2)
        if (t.categoria !== ee.categoria) {
          const catCanc = sanitize(ee.categoria, true)
          daCancellare[catCanc] = daCancellare[catCanc] || []
          daCancellare[catCanc].push(ee)
          ee.categoria = t.categoria
          daAggiungere[catSan] = daAggiungere[catSan] || []
          daAggiungere[catSan].push(ee)
        }        
        daModificare[catSan] = daModificare[catSan] || []
        daModificare[catSan].push(t)
      }
    }
  }
  for (let t of tabelleImport) {
    if (daCancellare[t]) {
      for (let c of daCancellare[t]) {
        let idx = tabelleT[t].tabacchi.findIndex(x => String(x.codiceFornitore) === String(c.codiceFornitore))
        if (idx > -1) {
          tabelleT[t].tabacchi.splice(idx, 1)
        }
      }
    }
    if (daAggiungere[t]) {
      tabelleT[t].tabacchi = tabelleT[t].tabacchi.concat(daAggiungere[t])
    }
    if (daModificare[t]) {
      for (let v of daModificare[t]) {
        let idx = tabelleT[t].tabacchi.findIndex(x => String(x.codiceFornitore) === String(v.codiceFornitore))
        if (idx > -1) {
          let tt = tabelleT[t].tabacchi[idx]
          tt = { ...tt, ...v }
          const hs = calcolaHash(tt)
          tt.hash = hs
          tabelleT[t].tabacchi[idx] = tt
        }
      }
    }
    try {
      let datiModificati = false
      if (!tabelleT[t].impostazioni.ultimaElaborazione || moment().diff(tabelleT[t].impostazioni.ultimaElaborazione, 'hours') > 12) {
        datiModificati = true
      }
      if ((daAggiungere[t] && daAggiungere[t].length > 0) || (daModificare[t] && daModificare[t].length > 0) || (daCancellare[t] && daCancellare[t].length > 0)) {
        tabelleT[t].impostazioni.ultimaModifica = new Date()
        datiModificati = true
      }
  
      if (datiModificati) {
        tabelleT[t].impostazioni.ultimaElaborazione = new Date()
        await tabelle.creaRigaTabella(tabelleT[t])
      }

    } catch (error) {
      console.log(`creaElementiCategoria: ${error}`)
      return []
    }
  }
/*   if (aggiuntaTabella) {
    _.set(backoffice, 'impostazioni.ordiniPeriodici.tabelleImport', tabelleImport)
    await configurazioni.modificaConfigurazione(backoffice)
  }
 */
  // Imposta la data di aggiornamento globale
  // TODO: cancellare "tabacchi" da 'anagrafica_tabacchi'
  let tabella = await tabelle.getTabella('anagrafica_tabacchi')
  if (aggiuntaTabella) {
    tabella.impostazioni.tabelleImport = tabelleImport
  }  
  tabella.impostazioni.ultimaElaborazione = new Date()
  await tabelle.creaRigaTabella(tabella)
}
